import {
  useWSModalCustom,
  useWSSnackbar,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { queriesWorkItems } from "@query";

type Props = {
  workItemId: string;
  name: string;
} & WSModalCustomProps<any>;

export const ModalRemoveItem: React.FC<Props> = ({
  workItemId,
  name,
  ...props
}) => {
  const [mutate, meta] = queriesWorkItems.deleteWorkItem.useMutation();

  const { openSnackbar } = useWSSnackbar();

  return (
    <WSModal
      size="S"
      title="Remove item"
      actions={{
        alignment: "fill",
        buttons: [
          {
            kind: "Tertiary",
            label: "Back",
            onClick: props.onClose
          },
          {
            kind: "Primary",
            destructive: true,
            label: "Remove",
            loading: meta.isLoading,
            onClick: () => {
              mutate(
                { workItemId },
                {
                  onSuccess: () => {
                    props.onClose(undefined);

                    openSnackbar({
                      icon: {
                        name: "check"
                      },
                      message: "Item removed"
                    });
                  },
                  onError: () => {
                    props.onClose(undefined);

                    openSnackbar({
                      icon: {
                        name: "alert-circle"
                      },
                      message: "Failed to remove item"
                    });
                  }
                }
              );
            }
          }
        ]
      }}
      {...props}
    >
      <WSList gap="L">
        <WSText.ParagraphSm color="gray500">
          Are you sure you want to remove the {name} work item?
        </WSText.ParagraphSm>
      </WSList>
    </WSModal>
  );
};

export const useModalRemoveItem = () => useWSModalCustom(ModalRemoveItem);
